import FJFileUpload from '../../../common/components/FJFileUpload/FJFileUpload';
import UploadIcon from '../../../assets/svg/upload-black.svg?react';
import FJGenerateButton from '../../../common/components/FJGenerateButton/FJGenerateButton';
import classNames from 'classnames';
import styles from './FJMobileImageEnhancerFooter.module.less';
import FJUtil from '../../../util/FJUtil';
import PropTypes from 'prop-types';
import FJLocalStore from '../../../store/FJLocalStore';
import FJHoverBoardGradation from '../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import { useMemo } from 'react';

const FJMobileImageEnhancerFooter = props => {
    const {
        onGenerate,
        taskStatus,
        freeNumCreation,
        creditNumber,
        isProjectLoading,
        uploadImg,
        uploadImageList,
        upscale,
        onChangeZoom,
    } = props;
    const useCredit = uploadImageList.length * 2;
    const isDisabled = FJUtil.isGeneratingStatus(taskStatus);
    const isFree = freeNumCreation > 0 && creditNumber < useCredit;
    const { width, height } = useMemo(() => {
        return uploadImageList[0] || {};
    }, [uploadImageList]);

    const imgPixelInfo = `${Math.floor(width * upscale)} * ${Math.floor(height * upscale)} px`;
    return (
        <div className={styles.container}>
            <div className={styles.upscale_box}>
                <div className={styles.upscale_left}>
                    <div className={styles.upscale_text}>{FJLocalStore._('upscale-size')}</div>
                    <div className={styles.upscale_info}>{imgPixelInfo}</div>
                </div>
                <div className={classNames(styles.upscale_right, isDisabled && styles.disabled)}>
                    {new Array(4).fill(0).map((item, index) => (
                        <FJHoverBoardGradation
                            key={index}
                            contentClassName={styles.upscale_item_content}
                            className={classNames(styles.upscale_item, { [styles.active]: upscale === index + 1 })}
                            active={upscale === index + 1}
                            onClick={() => {
                                onChangeZoom(index + 1);
                            }}
                            selectBgColor={'#fff'}
                        >
                            {`${index + 1}X`}
                        </FJHoverBoardGradation>
                    ))}
                </div>
            </div>
            <div className={styles.btn_box}>
                <FJFileUpload
                    className={classNames(styles.upload_box, isDisabled && styles.disabled)}
                    onUpload={uploadImg}
                >
                    <UploadIcon />
                </FJFileUpload>
                <FJGenerateButton
                    className={styles.generate_btn}
                    onClick={onGenerate}
                    taskStatus={taskStatus}
                    freeNumCreation={freeNumCreation}
                    isFree={isFree}
                    useCredit={useCredit}
                    isProjectLoading={isProjectLoading}
                />
            </div>
        </div>
    );
};
FJMobileImageEnhancerFooter.propTypes = {
    uploadImageList: PropTypes.array,
    onGenerate: PropTypes.func,
    taskStatus: PropTypes.string,
    freeNumCreation: PropTypes.number,
    creditNumber: PropTypes.number,
    isProjectLoading: PropTypes.bool,
    uploadImg: PropTypes.func,
    upscale: PropTypes.number,
    onChangeZoom: PropTypes.func,
};

export default FJMobileImageEnhancerFooter;
